import { createContext, memo, useCallback, useMemo } from 'react';
import { mediaPlaybackActions } from '../stores/AudioPlaybackStore';
import { MEDIA_BUFFER_STATUSES } from '../constants/MediaBufferStatus';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaPlaybackBufferContext = /*#__PURE__*/createContext({
  bufferStatus: MEDIA_BUFFER_STATUSES.INITIAL,
  setBufferStatus: () => {},
  percentLoaded: 0,
  setPercentLoaded: () => {}
});
const MediaPlaybackBufferProvider = /*#__PURE__*/memo(({
  bufferStatus,
  percentLoaded,
  mediaStateDispatch,
  children
}) => {
  const setBufferStatus = useCallback(state => {
    mediaStateDispatch(mediaPlaybackActions.setBufferStatus(state));
  }, [mediaStateDispatch]);
  const setPercentLoaded = useCallback(state => {
    mediaStateDispatch(mediaPlaybackActions.setPercentLoaded(state));
  }, [mediaStateDispatch]);
  const value = useMemo(() => ({
    bufferStatus,
    percentLoaded,
    setBufferStatus,
    setPercentLoaded
  }), [bufferStatus, percentLoaded, setBufferStatus, setPercentLoaded]);
  return /*#__PURE__*/_jsx(MediaPlaybackBufferContext.Provider, {
    value: value,
    children: children
  });
});
export { MediaPlaybackBufferProvider };